import { render, staticRenderFns } from "./ContentIndexTopicRow.vue?vue&type=template&id=f5a0a42c"
import script from "./ContentIndexTopicRow.vue?vue&type=script&lang=js"
export * from "./ContentIndexTopicRow.vue?vue&type=script&lang=js"
import style0 from "./ContentIndexTopicRow.vue?vue&type=style&index=0&id=f5a0a42c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports